import { Component, Input } from '@angular/core';
import { SportsService } from '../../../../services/sport.service';
import { UtilitiesService } from '../../../../services/utilities.service';
import { ScoresSportsService } from '../../../../services/scores-sports.service';
import { environment } from '../../../../../environments/environment';
import { NzSkeletonComponent } from 'ng-zorro-antd/skeleton';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ScoresFootballTeamComponent } from '../../../../components/shared/scores-football-team/scores-football-team.component';
import { ScoresSportsTeamComponent } from '../../../../components/shared/scores-sports-team/scores-sports-team.component';
import { NoResultComponent } from '../../../../components/shared/no-result/no-result.component';

@Component({
  selector: 'app-next-matches',
  standalone: true,
  imports: [
    NzSkeletonComponent,
    CommonModule,
    TranslateModule,
    ScoresFootballTeamComponent,
    ScoresSportsTeamComponent,
    NoResultComponent
  ],
  templateUrl: './next-matches.component.html',
  styleUrl: './next-matches.component.scss',
})
export class NextMatchesComponent {
  @Input() idCompetition: string = '';
  @Input() type: string = 'Competition';
  @Input() hasFavoriteSport: string = '';

  dashboardCompetitionsNext: Array<{
    date: string;
    dateSearch: string;
    data: any;
    load: boolean;
  }> = [];
  filterSelected: any = 'All';
  loaderMatches = true;

  urlSVG = environment.urlIcon;
  urlIMG = environment.urlIMG;

  constructor(
    private scoresServices: ScoresSportsService,
    public utilityService: UtilitiesService,
    public readonly menuServices: SportsService
  ) {}

  ngOnChanges(): void {
    this.loaderMatches = true;
    this.loadDashboard(this.idCompetition);
  }

  private loadDashboard(id: string) {
    this.dashboardCompetitionsNext = [];
    // for (let i = 0; i < 5; i++) {
    //   const dateSearch: any = moment()
    //     .tz(moment.tz.guess())
    //     .add(i + 1, 'd')
    //     .format('YYYYMMDD')
    //     .toString();
    //   this.dashboardCompetitionsNext.push({
    //     date: moment()
    //       .tz(moment.tz.guess())
    //       .add(i + 1, 'd')
    //       .format('DD-MM-YYYY')
    //       .toString(),
    //     dateSearch,
    //     data: [],
    //     load: true,
    //   });
    // }

    for (let i = 0; i < 5; i++) {
      let currentDate = new Date();

      currentDate.setDate(currentDate.getDate() + (i + 1));

      const dateSearch =
        currentDate.getFullYear().toString() +
        String(currentDate.getMonth() + 1).padStart(2, '0') +
        String(currentDate.getDate()).padStart(2, '0');

      const date =
        String(currentDate.getDate()).padStart(2, '0') +
        '-' +
        String(currentDate.getMonth() + 1).padStart(2, '0') +
        '-' +
        currentDate.getFullYear().toString();

      this.dashboardCompetitionsNext.push({
        date: date,
        dateSearch: dateSearch,
        data: [],
        load: true,
      });
    }

    this.loaderMatches = false;
    this.dashboardCompetitionsNext.forEach((elem: any) => {
      this.scoresServices
        .getScheduleResultsById(
          elem.dateSearch,
          'All',
          id,
          this.type,
          false,
          this.hasFavoriteSport
        )
        .subscribe(
          (response: any) => {
            if (response.status) {
              elem.data = response.data;
              elem.load = false;
            } else elem.load = false;
          },
          () => {
            elem.data = [];
            elem.load = false;
          }
        );
    });
  }
}
